import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppLayout } from "../components/Index";
import PrivateRoute from "../components/PrivateRoute";
import Security from "../pages/Security/index";
import SignIn from "../pages/SignIn";
import DashBoard from "../pages/DashBoard";
import NotFound from "../pages/404";
import Config from "../pages/Config";
import Home from "../pages/Home";
import Report from "../pages/Relatorios";
import Register from "../pages/Register";
import Devices from "../pages/Devices";
import ListSublines from "../pages/ListSublines";
import CreateSublineForm from "../pages/CreateSublineForm";
import EditFormSubline from "../pages/EditFormSubline";
import ListAreas from "../pages/ListAreas";
import CreateAreaForm from "../pages/CreateAreaForm";
import EditFormArea from "../pages/EditFormArea";
import ListPlants from "../pages/ListPlants";
import CreatePlantForm from "../pages/CreatePlantForm";
import EditFormPlant from "../pages/EditFormPlant";
import ListProductionUnits from "../pages/ListProductionUnits";
import CreateProductionUnitForm from "../pages/CreateProductionUnitForm";
import EditFormProductionUnit from "../pages/EditFormProductionUnit";
import PlantDetails from "../pages/PlantDetails";
import ProductionUnitDetails from "../pages/ProductionUnitDetails";
import AreaDetails from "../pages/AreaDetails";
import SublineDetails from "../pages/SublineDetails";
import RegisterStation from "../pages/RegisterStation";
import RegisterDeviceParam from "../pages/RegisterDeviceParam";
import RegisterCompany from "../pages/RegisterCompany";
import ListOperation from "../pages/ListOperation";
import OperationDetails from "../pages/OperationDetails";
import ListFailures from "../pages/ListFailures";
import EditFormFailure from "../pages/EditFormFailure";
import FailureTabs from "../pages/FailureTabs";
import CreateFamilyForm from "../pages/CreateFamilyForm";
import CreateUserForm from "../pages/CreateUserForm";
import EditUserForm from "../pages/EditUserForm";
import EditGroupForm from "../pages/EditGroupForm";
import EditFormFamily from "../pages/EditFormFamily";
import FamilyDetails from "../pages/FamilyDetails";
import ListFamilies from "../pages/ListFamilies";
import CreateProductForm from "../pages/CreateProductForm";
import EditFormProduct from "../pages/EditFormProduct";
import ProductDetails from "../pages/ProductDetails";
import ListProducts from "../pages/ListProducts";
import HomeDashboard from "../pages/HomeDashboard";
import FastResponse from "../pages/FastResponse";
import ListActionPlan from "../pages/ListActionPlans";
import FastResponseEmail from "../pages/FastResponseEmail";
import ListErrorProof from "../pages/ListErrorProof";
import FailureAnalysis from "../pages/FailureAnalysis";
import CreateActionPlan from "../pages/CreateActionPlan";
import CreateOperationForm from "../pages/CreateOperationForm";
import EditFormOperation from "../pages/EditFormOperation";
import CreateFailureForm from "../pages/CreateFailureForm";
import ManageActionPlan from "../pages/ManageActionPlan";
import CreateFmeaForm from "../pages/CreateFmeaForm";
import Step1 from "../pages/FmeaAiagVda/Step1";
import Step2 from "../pages/FmeaAiagVda/Step2";
import Step3 from "../pages/FmeaAiagVda/Step3";
import Step4 from "../pages/FmeaAiagVda/Step4";
import PlaceholderStep from "../pages/FmeaAiagVda/PlaceholderStep";
import ListFmea from "../pages/ListFmea";
import FmeaDetails from "../pages/FmeaDetails";
import EditFormFmea from "../pages/EditFormFmea";
import AssignFamiliesToLine from "../pages/AssignFamiliesToLine";
import CreateLineForm from "../pages/CreateLineForm";
import ListLines from "../pages/ListLines";
import EditLineForm from "../pages/EditLineForm";
import LineDetails from "../pages/LineDetails";
import ReportFailuresByOperation from "../pages/ReportFailuresByOperation";
import ReportGrossVolumeProduced from "../pages/ReportGrossVolumeProduced";
import ReportOeePerformance from "../pages/ReportOeePerformance";
import ReportStatePareto from "../pages/ReportStatePareto";
import ReportHourlyProduction from "../pages/ReportHourlyProduction";
import ReportPreparationTime from "../pages/ReportPreparationTime";
import ReportAccumulatedProduction from "../pages/ReportAccumulatedProduction";
import ReportSynoptic from "../pages/ReportSynoptic";
import ReportDashboard from "../pages/ReportDashboard";
import ReportTimeline from "../pages/ReportTimeline";
import CreateFamilyFmeaForm from "../pages/CreateFamilyFmeaForm";
import SelectInheritedFailures from "../pages/SelectInheritedFailures";
import ListFamilyFmea from "../pages/ListFamilyFmea";
import EditFormFamilyFmea from "../pages/EditFormFamilyFmea";
import FamilyFmeaDetails from "../pages/FamilyFmeaDetails";
import UsersCrud from "../pages/Users";
import GroupsPage from "../pages/Groups";
import LinkUserPlant from "../pages/LinkUserPlant";
import OccupancyMap from "../pages/OccupancyMap";

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/*" element={<NotFound />} />
    <Route path="/" element={<Security />} />
    <Route path="/login" element={<SignIn />} />
    <Route element={<PrivateRoute />}>
      <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<DashBoard />} />
        <Route path="/home" element={<Home />} />

        {/* Monitoramento (ao vivo) */}
        <Route path="/occupancy-map" element={<OccupancyMap />} />
        <Route path="/config" element={<Config />} />
        
        {/* Users & Groups */}
        <Route path="/users" element={<UsersCrud />} />
        <Route path="/users/create" element={<CreateUserForm />} />
        <Route path="/users/:id/edit" element={<EditUserForm />} />
        <Route path="/users/:id/link-plant" element={<LinkUserPlant />} />
        
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:groupId/edit" element={<EditGroupForm />} />
        <Route path="/groups/:groupId/permissions" element={<GroupsPage />} /> {/* Assuming permissions is inside Groups */}

        {/* Master Data */}
        <Route path="/families" element={<ListFamilies />} />
        <Route path="/families/create" element={<CreateFamilyForm />} />
        <Route path="/families/:id/edit" element={<EditFormFamily />} />
        <Route path="/families/:id" element={<FamilyDetails />} />

        <Route path="/products" element={<ListProducts />} />
        <Route path="/products/create" element={<CreateProductForm />} />
        <Route path="/products/:id/edit" element={<EditFormProduct />} />
        <Route path="/products/:id" element={<ProductDetails />} />

        {/* Structural Management (Existing Standard) */}
        <Route path="/plants" element={<ListPlants />} />
        <Route path="/plants/create" element={<CreatePlantForm />} />
        <Route path="/plants/:id/edit" element={<EditFormPlant />} />
        <Route path="/plants/:id" element={<PlantDetails />} />

        <Route path="/production-units" element={<ListProductionUnits />} />
        <Route path="/production-units/create" element={<CreateProductionUnitForm />} />
        <Route path="/production-units/:id/edit" element={<EditFormProductionUnit />} />
        <Route path="/production-units/:id" element={<ProductionUnitDetails />} />

        <Route path="/areas" element={<ListAreas />} />
        <Route path="/areas/create" element={<CreateAreaForm />} />
        <Route path="/areas/:id/edit" element={<EditFormArea />} />
        <Route path="/areas/:id" element={<AreaDetails />} />

        <Route path="/lines" element={<ListLines />} />
        <Route path="/lines/create" element={<CreateLineForm />} />
        <Route path="/lines/:id/edit" element={<EditLineForm />} />
        <Route path="/lines/:id" element={<LineDetails />} />
        <Route path="/lines/assign-families/:lineId" element={<AssignFamiliesToLine />} />

        <Route path="/sublines" element={<ListSublines />} />
        <Route path="/sublines/create" element={<CreateSublineForm />} />
        <Route path="/sublines/:id/edit" element={<EditFormSubline />} />
        <Route path="/sublines/:id" element={<SublineDetails />} />

        <Route path="/operations" element={<ListOperation />} />
        <Route path="/operations/create" element={<CreateOperationForm />} />
        <Route path="/operations/:id/edit" element={<EditFormOperation />} />
        <Route path="/operations/:id" element={<OperationDetails />} />

        {/* Quality & FMEA */}
        <Route path="/fmeas" element={<ListFmea />} />
        <Route path="/fmeas/create" element={<CreateFmeaForm />} />
        <Route path="/fmeas/:fmeaId/edit" element={<EditFormFmea />} />
        <Route path="/fmeas/:fmeaId" element={<FmeaDetails />} />
        
        {/* Nested Failures & Action Plans */}
        <Route path="/fmeas/:fmeaId/failures" element={<ListFailures />} />
        <Route path="/fmeas/:fmeaId/failures/create" element={<CreateFailureForm />} />
        <Route path="/fmeas/:fmeaId/failures/:id/edit" element={<EditFormFailure />} />
        <Route path="/fmeas/:fmeaId/failures/:failureId/:tab" element={<FailureTabs />} />
        
        <Route path="/fmeas/:fmeaId/failures/:failureId/action-plans" element={<ListActionPlan />} />
        <Route path="/fmeas/:fmeaId/failures/:failureId/action-plans/create" element={<CreateActionPlan />} />
        <Route path="/fmeas/:fmeaId/failures/:failureId/action-plans/:id/edit" element={<ManageActionPlan />} />

        {/* FMEA Steps */}
        <Route path="/fmeas/:fmeaId/steps/1" element={<Step1 />} />
        <Route path="/fmeas/:fmeaId/steps/2" element={<Step2 />} />
        <Route path="/fmeas/:fmeaId/steps/3" element={<Step3 />} />
        <Route path="/fmeas/:fmeaId/steps/4" element={<Step4 />} />
        <Route path="/fmeas/:fmeaId/steps/:stepNumber" element={<PlaceholderStep />} />
        <Route path="/fmeas/:fmeaId/select-inherited-failures" element={<SelectInheritedFailures />} />

        <Route path="/family-fmeas" element={<ListFamilyFmea />} />
        <Route path="/family-fmeas/create" element={<CreateFamilyFmeaForm />} />
        <Route path="/family-fmeas/:id/edit" element={<EditFormFamilyFmea />} />
        <Route path="/family-fmeas/:id" element={<FamilyFmeaDetails />} />
        
        {/* Nested Failures for Family FMEAs */}
        <Route path="/family-fmeas/:fmeaId/failures" element={<ListFailures />} />
        <Route path="/family-fmeas/:fmeaId/failures/create" element={<CreateFailureForm />} />
        <Route path="/family-fmeas/:fmeaId/failures/:id/edit" element={<EditFormFailure />} />
        <Route path="/family-fmeas/:fmeaId/failures/:failureId/:tab" element={<FailureTabs />} />

        {/* Miscellaneous */}
        <Route path="/companies/create" element={<RegisterCompany />} />
        <Route path="/reports/failures-by-operation" element={<ReportFailuresByOperation />} />
        <Route path="/reports/gross-volume-produced" element={<ReportGrossVolumeProduced />} />
        <Route path="/reports/oee-performance" element={<ReportOeePerformance />} />
        <Route path="/reports/state-pareto" element={<ReportStatePareto />} />
        <Route path="/reports/hourly-production" element={<ReportHourlyProduction />} />
        <Route path="/reports/preparation-time" element={<ReportPreparationTime />} />
        <Route path="/reports/accumulated-production" element={<ReportAccumulatedProduction />} />
        <Route path="/reports/synoptic" element={<ReportSynoptic />} />
        <Route path="/monitoring/dashboard" element={<ReportDashboard />} />
        <Route path="/monitoring/timeline" element={<ReportTimeline />} />
        <Route path="/error-proofs" element={<ListErrorProof />} />
        <Route path="/failure-analysis" element={<FailureAnalysis />} />
        <Route path="/fast-response" element={<FastResponse />} />
        <Route path="/fast-response-email" element={<FastResponseEmail />} />

        {/* Legacy / Others */}
        <Route path="/home-dashboard" element={<HomeDashboard />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/stations/register" element={<RegisterStation />} />
        <Route path="/devices/register-param" element={<RegisterDeviceParam />} />
        <Route path="/register" element={<Register />} />
        <Route path="/report" element={<Report />} />
      </Route>
    </Route>
  </Routes>
);
export default AppRoutes;
